import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  ModalCloseButton,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

/** Confirmモーダルのprops型定義 */
interface ConfirmModalProps {
  /** モーダルの表示状態 */
  isOpen: boolean;
  /** モーダルのタイトル */
  title: string;
  /** モーダルのメッセージ（JSX要素も可） */
  message: React.ReactNode;
  /** OKボタン押下時の処理 */
  onOk: () => void;
  /** キャンセルボタン押下時の処理 */
  onCancel: () => void;
  /** OKボタンのラベル（省略時: 共通 "OK"） */
  okLabel?: string;
  /** キャンセルボタンのラベル（省略時: 共通 "キャンセル"） */
  cancelLabel?: string;
}

/**
 * 汎用Confirmモーダルコンポーネント
 * @param isOpen モーダルの表示状態
 * @param title モーダルのタイトル
 * @param message モーダルのメッセージ
 * @param onOk OKボタン押下時の処理
 * @param onCancel キャンセルボタン押下時の処理
 * @param okLabel OKボタンのラベル（省略時: 共通 "OK"）
 * @param cancelLabel キャンセルボタンのラベル（省略時: 共通 "キャンセル"）
 * @returns Confirmモーダルコンポーネント
 */
const ConfirmModal: React.FC<ConfirmModalProps> = ({
  isOpen,
  title,
  message,
  onOk,
  onCancel,
  okLabel,
  cancelLabel,
}) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{title}</ModalHeader>
        <ModalCloseButton />
        <ModalBody whiteSpace="pre-wrap">{message}</ModalBody>
        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onOk}>
            {okLabel ?? t('common.button.ok')}
          </Button>
          <Button onClick={onCancel}>
            {cancelLabel ?? t('common.button.cancel')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;
